import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {Auction, User} from 'domain-models'
import {currency, hasFlag} from 'filters'
import _ from 'lodash'
import React from 'react'
import {setAuctions} from 'redux/actions'
import {store} from 'store'
import {connect} from 'react-redux'
import {GlobalState} from '../../state'
import {AuctionsState} from '../../redux/reducers/AuctionReducer'
import Trans from '../Trans'

type AuctionPriceProps = {
  auction: Auction
  small?: boolean
  user: User
  auctionsState: AuctionsState
}

type State = {}

class AuctionPrice extends React.Component<AuctionPriceProps, State> {
  private user = this.props.user

  constructor(props: AuctionPriceProps) {
    super(props)
  }

  componentDidMount() {
    const auctionState = this.props.auctionsState
    const highestBidder = _.maxBy(this.props.auction.round.bids, bid => {
      return _.toInteger(bid.Bid)
    })
    if ((highestBidder && !this.props.auction.highestBid) || (highestBidder && highestBidder.Bid !== this.props.auction.highestBid)) {
      this.props.auction.highestBid = highestBidder ? highestBidder.Bid : null
      this.props.auction.highestBidder = highestBidder
      store.dispatch(setAuctions(auctionState.auctions))
    }
  }

  render() {
    const {auction} = this.props
    const {round} = auction
    const agent = _.first(_.get(round, 'agents', []))

    return round.Type === 0 ? (
      <div className='bg-orange-100 text-orange-600 text-xs w-full px-4 py-2'>
        <div className={'font-semibold' + (this.props.small ? ' text-lg' : ' text-3xl')}>
          {round.PriceCall ?
            <div className='flex flex-col'>
              <div>
                <span className='mr-2'>{round.bid ? currency(round.bid.Bid) : <Trans>Kein Gebot</Trans>}</span>

                {
                  !this.props.small || round.bid ?
                    <span className='text-xs font-normal'>{round.bid ? <Trans>Ihr Gebot</Trans> : ''}</span>
                    : null
                }
              </div>
              <div className='text-xs'>
                {!!auction.isOutbid && round.bid ? (
                  <span className='text-red-700'>
                    <Icon icon='exclamation-triangle' /> <Trans>Sie wurden überboten</Trans>
                  </span>
                ) : (
                  <><Trans>Orientierungspreis</Trans> {currency(round.PriceCall)}</>
                )}
              </div>
            </div>
            :
            (
              <div className='flex flex-col'>
                <div>
                  <span className='mr-2'>{round.bid ? currency(round.bid.Bid) : <Trans>Kein Preis abgegeben</Trans>}</span>

                  {
                    !this.props.small || round.bid ?
                      <span className='text-xs font-normal'>{round.bid ? <Trans>Ihr Gebot</Trans> : null}</span>
                      : null
                  }
                </div>

                {
                  this.props.small ? null :
                    !!auction.isOutbid && round.bid ?
                      <div className='text-xs text-red-700'>
                        <Icon icon='exclamation-triangle' /> <Trans>Sie wurden überboten</Trans>
                      </div>
                      :
                      <div className='text-xs'>&nbsp;</div>
                }

                {
                  round.UseNetPrices && hasFlag(_.get(auction.subjects, '0.vehicle', {}), 'SellFlags', 32768) ?
                    <span className='text-xs font-bold ml-2'>(<Trans>NETTO-Preis</Trans>)</span>
                    : null
                }
              </div>
            )
          }
        </div>
      </div>
    ) : round.Type === 1 ?
      (
        <div className='bg-blue-100 text-blue-500 text-xs w-full px-4 py-2'>
          <div className={'font-semibold' + (this.props.small ? ' text-lg' : ' text-3xl')}>
            <div className='flex flex-col'>
              <div>
                <span className='mr-1'>{auction.highestBid ? currency(auction.highestBid) : <Trans>Keine Gebote</Trans>}</span>
                <span className='text-xs font-normal'>{auction.highestBid ? <Trans>Höchstgebot</Trans> : null}</span>
                {
                  round.UseNetPrices && hasFlag(_.get(auction.subjects, '0.vehicle', {}), 'SellFlags', 32768) ?
                    <span className='text-xs font-bold ml-2'>(<Trans>NETTO-Preis</Trans>)</span>
                    : null
                }
              </div>
              <div className='text-xs'>
                {
                  auction.highestBidder && auction.highestBidder.BidderId === this.user.ars_id ?
                    agent ?
                      <span className={'text-xs text-green-700'}>
                        <Icon icon='check' /> <Trans>Biet-Agent aktiv</Trans>: {currency(_.get(agent, 'max_bid', 0))}</span>
                      :
                      <span className={'text-xs text-blue-700'}>
                        <Icon icon='check' /> <Trans>Sie sind Höchstbietender</Trans></span>
                    :
                    this.props.small ? null :
                      <div className='text-xs'>&nbsp;</div>
                }
              </div>
            </div>
          </div>
        </div>
      )
      : round.Type === 2 && round.FixedPrice ?
        (
          <div className='bg-purple-100 text-purple-500 text-xs w-full px-4 py-2'>
            <div className={'font-semibold' + (this.props.small ? ' text-lg' : ' text-3xl')}>
              <div className='flex flex-col'>
                <div>
                  <span className='mr-1'>{currency(round.FixedPrice)}</span>
                  <span className='text-xs font-normal'><Trans>Sofort Kauf</Trans></span>

                  {
                    round.UseNetPrices && hasFlag(_.get(auction.subjects, '0.vehicle', {}), 'SellFlags', 32768) ?
                      <span className='text-xs font-bold ml-2'>(<Trans>NETTO-Preis</Trans>)</span>
                      : null
                  }
                </div>

                {
                  this.props.small ? null :
                    <div className='text-xs'>&nbsp;</div>
                }
              </div>
            </div>
          </div>
        )
        : null
  }
}

export default connect((state: GlobalState) => ({
  user: state.user,
  auctionsState: state.auctions
}))(AuctionPrice)
